import { usePhotoFilter } from '@/hooks/usePhotoFilter';

const Select = ({ name, value, onChange, options }: {
  name: string,
  value: string,
  onChange: (value: string) => void,
  options: string[]
}) => (
  <div className="flex flex-col items-center justify-center w-1/3">
    {/* <h2>{name}</h2> */}
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full p-2 border-2 border-gray-300 rounded-md"
    >
      {options.map((option) => (
        <option key={option} value={option}>
          {option || name || '---'}
        </option>
      ))}
    </select>
  </div>
);

export default function PhotoFilter() {
  const {
    states, provinces, regions, types,
    state, province, region, type,
    setState, setProvince, setRegion, setType,
    clearFilters
  } = usePhotoFilter();

  return (
    <div className="mt-4">
      <div className="flex flex-row flex-wrap items-center justify-center w-full">
        <Select name="State" value={state} onChange={setState} options={states} />
        <Select name="Province" value={province} onChange={setProvince} options={provinces} />
        <Select name="Region" value={region} onChange={setRegion} options={regions} />
      </div>
      <div className="flex flex-row items-center justify-around w-full my-2">
        <Select name="Type" value={type} onChange={setType} options={types} />
        <button
          className="p-2 border-2 border-gray-300 rounded-md cursor-pointer"
          onClick={clearFilters}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
